// 기다림 한도 — 작업개시 한 단계(html2canvas 그리기·작업 하나)가 안 끝나면 한도 뒤 오류로 넘긴다.
// 10-20 윈 outbox 3255: 쿠플러스 탭이 뒤로 가면 html2canvas 가 안 끝나 job 이 영원히 running(오늘 12건).
// 넘긴 promise 는 취소하지 못한다(뒤에 끝나면 그 칸을 덮을 수 있음 = 실제로 끝난 것이라 둔다).
export const TASK_TIMEOUT = 'TASK_TIMEOUT'
// html2canvas 한 번 그리기 한도(상세 이미지·한글 표시사항·사이즈표)
export const H2C_TIMEOUT_MS = 3 * 60 * 1000

export function withTimeout(promise, ms, label) {
  let timer
  const limit = new Promise((_, reject) => {
    timer = setTimeout(() => {
      const min = Math.max(1, Math.round(ms / 60000))
      const err = new Error(`${label} 이(가) ${min}분 안에 끝나지 않았습니다 — 쿠플러스 탭을 앞에 두고 다시 돌려주세요`)
      err.code = TASK_TIMEOUT
      reject(err)
    }, ms)
  })
  return Promise.race([Promise.resolve(promise), limit]).finally(() => clearTimeout(timer))
}

// html2canvas 복제 거름(ignoreElements) — 복제는 그리는 div·그 조상·head 의 같은 출처 css 만.
// 거름이 없으면 화면 전체(상품표 썸네일·iframe·다른 작업의 숨은 그림·외부 CDN css)를 숨은 iframe 에 복제하고
// 그것들이 끝날 때까지 한도 없이 기다려, 안 끝나는 것 하나에 매 그림이 3분 한도에 걸렸다
// (라벨 윈 3469 PR261021-359DEB · 상세이미지·사이즈표 윈 3517 PR261021-17E230).
export function cloneOnly(container) {
  const sameOrigin = (href) => {
    try { return new URL(href, window.location.href).origin === window.location.origin } catch (e) {
      console.error(`[html2canvas 복제] css 주소를 못 읽어 복제에서 뺌: ${href} — ${e.message}`)
      return false
    }
  }
  return (el) => {
    if (el === container || el.contains(container) || container.contains(el)) return false
    if (document.head.contains(el)) return el.tagName === 'LINK' && !sameOrigin(el.href)
    return true
  }
}
